export enum ExtendedFieldsActionTypes {
  MANAGE_DRAWER = "MANAGE_EXTENDED_FIELDS_DRAWER",
  
  GET_EXTENDED_FIELDS = "GET_EXTENDED_FIELDS",
  GET_EXTENDED_FIELDS_SUCCESS = "GET_EXTENDED_FIELDS_SUCCESS",
  GET_EXTENDED_FIELDS_FAILURE = "GET_EXTENDED_FIELDS_FAILURE",
  
  NEW_EXTENDED_FIELD = "SAVE_EXTENDED_FIELD",
  NEW_EXTENDED_FIELD_SUCCESS = "SAVE_EXTENDED_FIELD_SUCCESS",
  NEW_EXTENDED_FIELD_FAILURE = "SAVE_EXTENDED_FIELD_FAILURE",

  UPDATE_EXTENDED_FIELD = "UPDATE_EXTENDED_FIELD",
  UPDATE_EXTENDED_FIELD_SUCCESS = "UPDATE_EXTENDED_FIELD_SUCCESS",
  UPDATE_EXTENDED_FIELD_FAILURE = "UPDATE_EXTENDED_FIELD_FAILURE",

  GET_EXTENDED_FIELD_SP_LIST = "GET_EXTENDED_FIELD_SP_LIST",
  GET_EXTENDED_FIELD_SP_LIST_SUCCESS = "GET_EXTENDED_FIELD_SP_LIST_SUCCESS",
  GET_EXTENDED_FIELD_SP_LIST_FAILURE = "GET_EXTENDED_FIELD_SP_LIST_FAILURE",

  GET_DATA_TYPES = "GET_DATA_TYPES",
  GET_DATA_TYPES_SUCCESS = "GET_DATA_TYPES_SUCCESS",
  GET_DATA_TYPES_FAILURE = "GET_DATA_TYPES_FAILURE",

  DELETE_EXTENDED_FIELD = "DELETE_EXTENDED_FIELD",
  DELETE_EXTENDED_FIELD_SUCCESS = "DELETE_EXTENDED_FIELD_SUCCESS",
  DELETE_EXTENDED_FIELD_FAILURE = "DELETE_EXTENDED_FIELD_FAILURE",
}